(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root = document) {
    root.querySelectorAll('[data-hero-video-scope]').forEach(scope => {
      const button = scope.querySelector('[data-hero-toggle]');
      const videos = [...scope.querySelectorAll('.hero__video')];
      if (!button || !videos.length || button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.hidden = false;
      videos.forEach(video => { video.controls = false; video.tabIndex = -1; });
      const sync = () => {
        const paused = !videos.some(video => !video.paused);
        button.textContent = '';
        button.dataset.paused = String(paused);
        button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
      };
      const pause = () => videos.forEach(video => video.pause());
      button.addEventListener('click', () => {
        if (videos.some(video => !video.paused)) pause();
        else videos.forEach(video => video.play().catch(sync));
      });
      videos.forEach(video => { video.addEventListener('play', sync); video.addEventListener('pause', sync); });
      reducedMotion.addEventListener('change', event => { if (event.matches) pause(); });
      if (!reducedMotion.matches) videos.forEach(video => video.play().catch(sync));
      sync();
    });
    root.querySelectorAll('[data-motion-scope]').forEach(scope => {
      const button = scope.querySelector('[data-motion-toggle]');
      if (!button || button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.hidden = false;
      const setPaused = paused => {
        scope.dataset.motionPaused = String(paused);
        button.textContent = '';
        button.dataset.paused = String(paused);
        button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
      };
      setPaused(reducedMotion.matches);
      button.addEventListener('click', () => setPaused(scope.dataset.motionPaused !== 'true'));
      reducedMotion.addEventListener('change', event => { if (event.matches) setPaused(true); });
      if (scope.matches('marquee-component')) {
        const hideCopies = () => {
          scope.querySelectorAll('.marquee__repeated-items').forEach((item, index) => {
            if (index > 0) { item.setAttribute('aria-hidden', 'true'); item.inert = true; }
          });
        };
        hideCopies();
        new MutationObserver(hideCopies).observe(scope, { childList: true, subtree: true });
      }
    });
    root.querySelectorAll('.ugc-track,.vtc-track').forEach(track => {
      if (track.dataset.keyboardReady) return;
      track.dataset.keyboardReady = 'true';
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const behavior = reducedMotion.matches ? 'auto' : 'smooth';
        if (event.key === 'Home' || event.key === 'End') track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior });
        else track.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * track.clientWidth * 0.8, behavior });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();
